/**
 * External dependencies
 */
export default class Callback {
    constructor(cscom) {
        if (!(this instanceof Callback)) {
            return new Callback(cscom);
        }
        this.cscom = cscom;
    }

    getCallback() {
        return this.cscom.req.get('/sgc/app/get-callback');
    }

    verifyCallback(code, hmac, host, shop, timestamp, tenantid) {
        // return this.cscom.req.get('/sgc/app/callback', details).then((result) => {
        //     return result;
        // });

        return this.cscom.req.get('/sgc/app/callback', { code, hmac, host, shop, timestamp, tenantid });
    }
}
